import { buildResourcefulRequests, buildSingularResourcefulRequests } from '@utils/requests'

export const resourcefulRequest = (resourceName) => {
  const basePath = `/api/${resourceName}`

  return buildResourcefulRequests(basePath)
}

export const singularResourcefulRequest = (resourceName) => {
  const basePath = `/api/${resourceName}`

  return buildSingularResourcefulRequests(basePath)
}
